import { Component, Input } from '@angular/core';
import { IDataTagTransfer } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-tag-account-transfer',
	templateUrl: './tag-account-transfer.component.html',
	styleUrls: ['./tag-account-transfer.component.scss']
})
export class TagAccountTransferComponent {
	@Input() item!: IDataTagTransfer;

	getClass(): string {
		return this.item.className ? this.item.className.join('') : '';
	}
}
